import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs';
import { LANGUAGES, TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'getStrategyImageByLang',
    pure: false
})
export class GetStrategyImageByLangPipe implements PipeTransform, OnDestroy {
    private asyncPipe: AsyncPipe;

    public constructor(private translateService: TranslateService, private injector: Injector) {
        this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
    }

    transform(index: number): string {
        return this.asyncPipe.transform(
            this.translateService.currentLang$.pipe(
                map(lang => {
                    return `assets/images/${index}${lang || LANGUAGES.AR}.avif`;
                })
            )
        );
    }

    ngOnDestroy() {
        this.asyncPipe.ngOnDestroy();
    }
}
